export const SET_SELECTED_STATE = "setSelectedState";
export const SET_SELECTED_CATEGORY = "setSelectedCategory";
export const DO_SEARCH = "doSearch";
export const FETCH_PLACE_DETAILS = "fetchPlaceDetails";
export const LOAD_PLACE_DETAILS_FROM_CACHE = "loadPlaceDetailsFromCache";
export const FETCH_FAQ = "fetchFAQ";

export const SUBMIT_REGISTER_FORM = "submitRegisterForm";
export const SUBMIT_SEND_MESSAGE = "submitSendMessage";
